import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
interface NavBarProps {
  onGetStarted: () => void;
}
export const NavBar = ({
  onGetStarted
}: NavBarProps) => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
    // Prevent body scroll when menu is open
    document.body.style.overflow = !isMenuOpen ? 'hidden' : 'unset';
  };
  const handleLinkClick = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = 'unset';
  };
  return <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white bg-opacity-90 shadow-sm backdrop-blur-sm py-3' : 'bg-transparent py-5'}`} data-id="element-359">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-360">
        <div className="flex items-center gap-2" data-id="element-361">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vTeCufxgWzcPtZAqvDy1jp/contextuality-logo.png" alt="Contextuality AI Logo" className="w-12 h-12 object-contain" data-id="element-362" />
          <span className="text-xl font-bold text-gray-900" data-id="element-363">
            Contextuality AI
          </span>
        </div>
        {/* Mobile Menu Button */}
        <button onClick={handleMenuClick} className="md:hidden p-2 text-gray-600 hover:text-gray-900" aria-label="Toggle menu" data-id="element-364">
          {isMenuOpen ? <XIcon size={24} data-id="element-365" /> : <MenuIcon size={24} data-id="element-366" />}
        </button>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-367">
          <a href="#signals" className="text-sm font-medium text-gray-700 hover:text-[#8679DF]" data-id="element-368">
            Signals
          </a>
          <a href="#how-it-works" className="text-sm font-medium text-gray-700 hover:text-[#8679DF]" data-id="element-369">
            How It Works
          </a>
          <a href="#security" className="text-sm font-medium text-gray-700 hover:text-[#8679DF]" data-id="element-370">
            Security
          </a>
          <a href="#teams" className="text-sm font-medium text-gray-700 hover:text-[#8679DF]" data-id="element-371">
            Why Contextuality
          </a>
        </nav>
        {/* Mobile Menu Overlay */}
        <div className={`md:hidden fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm transition-opacity duration-300 ${isMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={handleMenuClick} data-id="element-372" />
        {/* Mobile Navigation */}
        <nav className={`md:hidden fixed right-0 top-0 h-full w-[280px] bg-white transform transition-transform duration-300 ease-in-out ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-373">
          <div className="flex flex-col p-6" data-id="element-374">
            <div className="flex justify-end mb-8" data-id="element-375">
              <button onClick={handleMenuClick} className="p-2 text-gray-600 hover:text-gray-900" aria-label="Close menu" data-id="element-376">
                <XIcon size={24} data-id="element-377" />
              </button>
            </div>
            <a href="#signals" className="text-lg font-medium text-gray-900 hover:text-[#8679DF] py-3 border-b border-gray-100" onClick={handleLinkClick} data-id="element-378">
              Signals
            </a>
            <a href="#how-it-works" className="text-lg font-medium text-gray-900 hover:text-[#8679DF] py-3 border-b border-gray-100" onClick={handleLinkClick} data-id="element-379">
              How It Works
            </a>
            <a href="#security" className="text-lg font-medium text-gray-900 hover:text-[#8679DF] py-3 border-b border-gray-100" onClick={handleLinkClick} data-id="element-380">
              Security
            </a>
            <a href="#teams" className="text-lg font-medium text-gray-900 hover:text-[#8679DF] py-3" onClick={handleLinkClick} data-id="element-381">
              Why Contextuality
            </a>
          </div>
        </nav>
      </div>
    </header>;
};